import { Component, OnInit } from '@angular/core';
import { InscricoesTributariasService } from './../services/inscricoes-tributarias.service';
import { ErrorHandlerService } from './../errorHandler.service';
import { ToastrService } from 'ngx-toastr';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-inscricoes-tributarias',
  templateUrl: './inscricoes-tributarias.component.html',
  styleUrls: ['./inscricoes-tributarias.component.scss']
})
export class InscricoesTributariasComponent implements OnInit {

  numeroProtocolo: any = '';
  ccm: any;
  possiveisCcm: Array<any> = [];
  msgErro: boolean = false;
  exibeMsg: boolean = false;
  inscricaoIndisponivel: boolean = false;
  inscricaoConcedida: boolean = false;
  listaInscricoes: boolean = false;
  inscricaoBaixa: boolean = false;
  numeroInscricaoMunicipal: any;
  mensagemCompilada: any;
  escondeCcm: boolean;
  evento: Array<any> = [];
  erros: Array<any> = [];

  constructor(
    private InscricaoService: InscricoesTributariasService,
    private handlerError: ErrorHandlerService,
    private toastyService: ToastrService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
  }

  consultaCCM(){
    
    this.numeroProtocolo = this.numeroProtocolo.toUpperCase();

    this.inscricaoConcedida = false;
    this.listaInscricoes = false;
    this.inscricaoBaixa = false;
    this.escondeCcm = true;
    this.msgErro = false;

      this.InscricaoService.getCCM(this.numeroProtocolo)
      .then(res => {
        this.ccm = res;
        this.mensagemCompilada = this.sanitizer.bypassSecurityTrustHtml(this.ccm.mensagem)
        this.possiveisCcm = res.possiveisCcm.InscricaoMunicipal;
        this.msgErro = false;
        this.evento = res.evento;

        if(res.erros){
          for (let i = 0; i < res.erros.length; i++){
          res.erros[i] = this.sanitizer.bypassSecurityTrustHtml(res.erros[i])
          }
        }
        this.erros = res.erros;        

      if(this.ccm.numeroInscricaoMunicipal != null && this.ccm.possiveisCcm != null){
        if(this.ccm.possiveisCcm.InscricaoMunicipal.length == 0){
          for (let i = 0; i < this.evento.length; i++){
            if(this.evento[i] >= '500' && this.evento[i] <= '599' ){
              this.escondeCcm = true;
            } else {
              this.escondeCcm = false;
            }
          }
          this.inscricaoConcedida = true;
          this.listaInscricoes = false;
          this.inscricaoBaixa = false;
        }
      }

      if(this.ccm.numeroInscricaoMunicipal != null && this.ccm.possiveisCcm == null){
        for (let i = 0; i < this.evento.length; i++){
          if(this.evento[i] >= '500' && this.evento[i] <= '599' ){
            this.escondeCcm = true;
          } else {
            this.escondeCcm = false;
          }
        }
        this.inscricaoConcedida = true;
        this.listaInscricoes = false;
        this.inscricaoBaixa = false;
      }

      if(this.ccm.numeroInscricaoMunicipal == null && this.ccm.possiveisCcm != null){
        if(this.ccm.possiveisCcm.InscricaoMunicipal.length == 0){
          for (let i = 0; i < this.evento.length; i++){
            if(this.evento[i] >= '500' && this.evento[i] <= '599' ){
              this.escondeCcm = true;
            } else {
              this.escondeCcm = false;
            }
          }
          this.inscricaoConcedida = true;
          this.listaInscricoes = false;
          this.inscricaoBaixa = false;
        }
      }
      if(this.ccm.numeroInscricaoMunicipal == null && this.ccm.possiveisCcm != null){
        if(this.ccm.possiveisCcm.InscricaoMunicipal.length > 0){
          for (let i = 0; i < this.evento.length; i++){
            if(this.evento[i] >= '500' && this.evento[i] <= '599' ){
              this.inscricaoConcedida = false;
              this.listaInscricoes = false;
              this.inscricaoBaixa = true;
            } else {
              this.inscricaoConcedida = false;
              this.listaInscricoes = true;
              this.inscricaoBaixa = false;
            }
          }
        }
      }

      }).catch( err => {
        if(err.status == 401){
          this.handlerError.handle(err);
        } else {
          this.msgErro = true;
        }
      })
  
  }

  bloqueiaConsulta(){
    if(this.numeroProtocolo && this.numeroProtocolo.length < 13 || !this.numeroProtocolo){
      this.inscricaoIndisponivel = false;
      this.inscricaoConcedida = false;
      this.listaInscricoes = false;
      this.inscricaoBaixa = false;
      this.msgErro = false;
      return true;
    } else {
      return false;
    }
  }

  enviaCCM(){

    let body =  
    this.numeroInscricaoMunicipal = this.numeroInscricaoMunicipal
    
    this.InscricaoService.putCCM(this.numeroProtocolo, body)
    .then(res => {
      
      this.toastyService.success('Inscrição Municipal atualizada com sucesso!');
      this.listaInscricoes = false;
      this.inscricaoBaixa = false;
      this.consultaCCM();
    })
    .catch(err => {
      if(err.status == 500) {
        this.toastyService.error('Serviço indisponível no momento. Tente novamente em instantes!');
      } else {
        this.toastyService.error(err.error.detalhe);
      }
    })
  }

  enviaCCMBaixa(){

    let body;
    
    this.InscricaoService.putCCM(this.numeroProtocolo, body)
    .then(res => {
      
      this.toastyService.success('Dados enviados com sucesso!');
      this.listaInscricoes = false;
      this.inscricaoBaixa = false;
      this.consultaCCM();
    })
    .catch(err => {
      if(err.status == 500) {
        this.toastyService.error('Serviço indisponível no momento. Tente novamente em instantes!');
      } else {
        this.toastyService.error(err.error.detalhe);
      }
    })
  }

}
